export var compareTags = function compareTags(tag1, tag2) {
  return tag1.id > tag2.id ? 1 : -1;
};
//# sourceMappingURL=tags.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/tags.js
// module id = 776
// module chunks = 0